import * as React from 'react'
import { useState } from 'react'
import { useTimeoutFn } from 'react-use'
import { classNames } from 'primereact/utils'
import { resendVerification } from '../../api/auth'

export const RESEND_COOLDOWN_MS = 60000

type ResendState = 'cooldown' | 'ready' | 'sending' | 'resent'

export const SignupVerification: React.FC<{ email: string }> = ({ email }) => (
  <div className='d-flex flex-column align-items-center gap-3'>
    <div className='auth-popup-invitation-code-expired-logo'>
      <i className='bi bi-envelope fs-4' />
    </div>
    <h2 className='auth-popup-header'>Verify Your Email</h2>
    <div className='signup-verification-text'>Check your inbox and click the link to activate your account.</div>
    <div className='signup-verification-text'>We've sent a verification link to</div>
    <div className='bg-light rounded px-3 py-2 fw-semibold text-break'>{email}</div>
    <ResendVerification email={email} />
  </div>
)

const ResendVerification: React.FC<{ email: string }> = ({ email }) => {
  const [state, setState] = useState<ResendState>('cooldown')
  const [, , restartCooldown] = useTimeoutFn(() => setState('ready'), RESEND_COOLDOWN_MS)

  const onResend = async () => {
    if (state !== 'ready') {
      return
    }
    setState('sending')
    try {
      await resendVerification(email)
      setState('resent')
      restartCooldown()
    } catch (e) {
      console.error(e)
      setState('ready')
    }
  }

  if (state === 'resent') {
    return (
      <div className='signup-verification-text'>
        <i className='bi bi-check2 me-1' />
        We've resent the verification link.
      </div>
    )
  }

  return (
    <div className='signup-verification-text'>
      Haven't received the email?{' '}
      <button
        className={classNames('border-0 bg-transparent p-0 align-baseline', { 'opacity-50': state !== 'ready' })}
        onClick={onResend}
        disabled={state !== 'ready'}
        type='button'
      >
        <span className='auth-link-text auth-link-text-accent'>Resend</span>
      </button>
    </div>
  )
}
